import CourseAtlasClient from '@/models/services/courseatlas/client';
import { ICourse } from '@/models/services/courseatlas/entities';

const client = new CourseAtlasClient();

export {
	client,
	type ICourse,
};
